<template>
  <div class="container">
    <div class="handle-box">
      <el-form :model="queryCondition" ref="queryCondition" label-width="120px" class="searchForm">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="Category1" prop="pid">
              <el-select v-model="queryCondition.pid" clearable @change="changeCategory1()" style="width:100%">
                <el-option :key="index" v-for="(item,index) in categoryList1" :label="item.name" :value="item.tmCategoryId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="Category2" prop="tmCategoryId">
              <el-select v-model="queryCondition.tmCategoryId" clearable style="width:100%">
                <el-option :key="index" v-for="(item,index) in categoryList2" :label="item.name" :value="item.tmCategoryId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="center">
          <el-button size="mini" @click="queryData(1)" type="primary">{{$t('common.search')}}</el-button>
          <el-button size="mini" @click="restQueryForm" type="primary">{{$t('common.reset')}}</el-button>
        </el-row>
      </el-form>
    </div>
    <el-row class="action-btn-row">
      <el-button size="mini" class="btn" v-if="btnAdd" type="primary" @click="showDialog=true">{{$t('common.newBuilt')}}</el-button>
      <el-button size="mini" class="btn" v-if="btnDelete" type="danger" @click="deleteRow">{{$t('common.del')}}</el-button>
    </el-row>
    <span>Category2</span>
    <el-table ref="tableData" :data="tableData" row-key="tmCategoryId" border highlight-current-row>
      <el-table-column fixed sortable type="selection" width="55" align="center" :reserve-selection="true"></el-table-column>
      <el-table-column prop='pname' label="Category 1"></el-table-column>
      <el-table-column prop='name' label="Category 2"></el-table-column>
      <el-table-column prop='statusI18n' :label="$t('common.status')"></el-table-column>
      <el-table-column :label="$t('base.linePrice.operation')">
        <template slot-scope="scope">
          <div v-if="scope.row.status=='effective'" class="a-link" @click="disable(scope.row.tmCategoryId,'invalid')">Disable
          </div>
          <div v-if="scope.row.status=='invalid'" class="a-link" @click="disable(scope.row.tmCategoryId,'effective')">Enable
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount"></el-pagination>
    </div>
    <el-dialog :visible.sync="showDialog" width="30%">
      <el-form :model="info" ref="info" :rules="rules" label-width="110px">
        <el-form-item label="Category1" prop="pid">
          <el-select v-model="info.pid" clearable>
            <el-option :key="index" v-for="(item,index) in categoryList1" :label="item.name" :value="item.tmCategoryId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Category2" prop="name">
          <el-input v-model="info.name" clearable></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button type="primary" size="mini" @click="saveCategory">{{$t('common.submit')}}</el-button>
        <el-button type="primary" size="mini" @click="showDialog = false">{{$t('common.close')}}</el-button>
      </div>
    </el-dialog>
  </div>

</template>

<script>
import IcSelect from "@/components/common/icSelect";
import { apiService } from "@/api/material/material-master-data";
import GRIApi from "@/api/material/GRI";
import commonFunction from "@/utils/dataTableUtils";
import { Message } from "element-ui";

export default {
  components: { IcSelect },
  extends: commonFunction,
  data() {
    return {
      queryCondition: {
        pid: '',
        tmCategoryId: '',
        pageNum: 1,
        pageSize: 15,
        categoryLevel: 2
      },
      categoryList1: [],
      categoryList2: [],
      tableData: [],
      totalCount: 0,
      showDialog: false,
      btnAdd: false,
      btnDelete: false,
      info: { name: null, pid: null, categoryLevel: 2 },
      rules: {
        pid: [
          { required: true, message: this.$t("common.canNotBeEmpty"), trigger: "change" }
        ],
        name: [
          { required: true, message: this.$t("common.canNotBeEmpty"), trigger: "blur" }
        ]
      },
    }
  },
  created() {
    this.queryData(1)
    this.getCategory1()
    this.getUserType()
  },
  methods: {
    queryData(val) {
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      apiService.findListCategory(this.queryCondition).then((res) => {
        this.tableData = res.resultData;
        this.totalCount = res.totalCount;
      });
    },
    disable(tmCategoryId, status) {
      let that = this
      let data = {
        tmCategoryId: tmCategoryId,
        status: status
      }
      GRIApi.disableCategory(data).then((res) => {
        that.$message({
          message: this.$t("common.success"),
          type: "success"
        });
        this.queryData(1)
      });
    },
    saveCategory() {
      this.$refs.info.validate(valid => {
        if (valid) {
          GRIApi.saveCategory(this.info).then((res) => {
            this.$message({
              message: this.$t("common.success"),
              type: "success"
            });
            this.showDialog = false
            this.info.pid = null
            this.info.name = null
            this.queryData(1)
          });
        } else {
          Message({ message: that.$t('common.PleaseRequired'), type: "error" });
          return false;
        }
      });
    },
    getCategory1() {
      apiService.findCategory({ categoryLevel: 1 }).then((res) => {
        this.categoryList1 = res.data;
        console.log(res.data)
      });
    },
    //根据选中Category1查询Category2
    changeCategory1() {
      this.queryCondition.tmCategoryId = null
      this.categoryList2 = []
      this.categoryList3 = []
      apiService.findCategory({ categoryLevel: 2, pid: this.queryCondition.pid }).then((res) => {
        this.categoryList2 = res.data;
      });
    },
    async deleteRow() {
      let rows = this.$refs.tableData.selection;
      if (rows.length == 0) {
        this.$message({
          message: this.$t("common.pleaseSelectData"),
          type: "warning"
        });
      } else {
        if (await this.callConfirm()) {
          let ids = rows.map(data => data.tmCategoryId)
          GRIApi.deleteBatchIds(ids).then((res) => {
            if (res.code === '200') {
              Message({ message: this.$t('common.delSuccess'), type: "success" });
            } else {
              Message({ message: this.$t('common.delError'), type: "error" });
            }
            this.queryData();
          });
        }
      }
    },
    //查询条件重置方法
    restQueryForm: function () {
      this.$refs.queryCondition.resetFields();
      this.queryCondition.pageSize = 15;
      this.queryCondition.pageNum = 1;
      this.queryCondition.categoryLevel = 2;
    },
    getUserType() {
      let permission = JSON.parse(localStorage.getItem("ms_Permission"));
      for (let i = 0, len = permission.length; i < len; i++) {
        if (permission[i] == 'category2_add') {//新建
          this.btnAdd = true;
        }
        if (permission[i] == 'category2_delete') {//删除
          this.btnDelete = true;
        }
      }
    },
  }

}
</script>
<style lang="scss" scoped>
.searchBox_top {
  margin-bottom: 20px;
}

.el-table {
  margin-top: 10px;
}

.el-select {
  width: 100%;
}
</style>
<style lang="scss">
.materialGRIC1 {
  .headList {
  }
}
</style>
